export interface BlogPost {
  title: string;
  slug: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
  image: string;
  content?: string;
}

export const blogPosts: BlogPost[] = [
  {
    title: "Why Quick Access to Accountability Is a Key Step in Long-Term Mental Health",
    slug: "quick-access-accountability-mental-health",
    excerpt: "Accountability that's visible, easy to use, and hard to ignore—like widgets and quick-check apps—supports lasting behavior change. Here's why reducing friction and making progress visible matters for mental health.",
    author: "Habitualy Team",
    date: "2025-01-30",
    readTime: "9 min read",
    tags: ["accountability", "mental-health", "habits", "psychology", "behavior-change", "wellbeing", "progress-tracking"],
    featured: true,
    image: "/featured/8.png"
  },
  {
    title: "Why You Can't Stick to Habits (Even When They Help) — Especially With ADHD",
    slug: "why-you-cant-stick-to-habits-adhd",
    excerpt: "If you know what habits help you but still can't stick to them, you're not alone. For ADHD brains, this isn't a character flaw—it's neurology. Discover why traditional habit advice fails and what actually works.",
    author: "Habitualy Team",
    date: "2025-01-20",
    readTime: "10 min read",
    tags: ["adhd", "habits", "psychology", "neurodivergent", "motivation", "discipline", "routine"],
    featured: true,
    image: "/featured/7.png"
  },
  {
    title: "How to Build Morning Routines That Stick: The Time-Blocking Method",
    slug: "how-to-build-morning-routines-with-habitualy",
    excerpt: "Discover how to create powerful morning routines using time-blocking in Habitualy. Learn why grouping habits together works better than spreading them throughout the day, backed by research and practical examples.",
    author: "Habitualy Team",
    date: "2025-01-05",
    readTime: "7 min read",
    tags: ["morning-routine", "habit-building", "time-blocking", "productivity", "habit-tracking"],
    featured: true,
    image: "/featured/6.png"
  },
  {
    title: "3 Best ADHD Tools That Actually Work (From Someone Who's Tried Them All)",
    slug: "3-best-adhd-tools",
    excerpt: "Cut through the noise. After testing dozens of productivity apps, here are the only three tools that actually help ADHD brains stay organized, focused, and productive.",
    author: "Habitualy Team",
    date: "2025-06-26",
    readTime: "7 min read",
    tags: ["adhd", "tools", "productivity", "neurodivergent", "focus"],
    featured: true,
    image: "/featured/5.png"
  },
  {
    title: "How to Color Code Your Habits",
    slug: "how-to-color-code-habits",
    excerpt: "Discover the psychology of color in habit tracking and learn three powerful ways to use color coding to enhance your habit-building journey. From categorization to priority setting, colors can transform how you view and maintain your habits.",
    author: "Habitualy",
    date: "2025-05-28",
    readTime: "6 min",
    tags: ["habits", "psychology", "productivity", "organization"],
    featured: true,
    image: "/featured/4.png"
  },
  {
    title: "Streaks: Why It Takes 30 Days to Build a Habit",
    slug: "streaks-why-30-days-to-build-habit",
    excerpt: "Uncover the truth behind the 30-day habit formation myth. Explore the latest research on how long it really takes to build lasting habits and why streaks are your secret weapon.",
    author: "Habitualy",
    date: "2025-05-27",
    readTime: "7 min",
    tags: ["habits", "streaks", "psychology", "research", "behavior-change"],
    featured: true,
    image: "/featured/3.png"
  },
  {
    title: "Should You Have a Daily Checklist?",
    slug: "should-you-have-daily-checklist",
    excerpt: "Discover why daily checklists are one of the most powerful tools for clarity, focus, and habit formation. Learn the science behind why they work and how to build one that sticks.",
    author: "Habitualy",
    date: "2025-05-26",
    readTime: "5 min",
    tags: ["productivity", "checklists", "habits", "focus"],
    featured: true,
    image: "/featured/2.png"
  },
  {
    title: "Why Grids Can Boost Your Productivity",
    slug: "why-grids-boost-productivity",
    excerpt: "Discover the science and psychology behind visual habit tracking. Learn why simple grids are more effective than complex productivity systems for building lasting habits.",
    author: "Habitualy",
    date: "2025-05-25",
    readTime: "6 min",
    tags: ["productivity", "habits", "psychology", "visual-tracking"],
    featured: false,
    image: "/featured/1.png"
  }
];

export const getFeaturedPosts = (): BlogPost[] => {
  return blogPosts.filter(post => post.featured);
};

export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};

export const getPostsByTag = (tag: string): BlogPost[] => {
  return blogPosts.filter(post => post.tags.includes(tag));
};

export const getAllTags = (): string[] => {
  const tags = new Set<string>();
  blogPosts.forEach(post => {
    post.tags.forEach(tag => tags.add(tag));
  });
  return Array.from(tags).sort();
}; 